import { API } from "@/main.js";

const state = {
  companiesUsers: {
    loading: true,
    data: []
  }
};

const getters = {
  companiesUsers_loading: state => state.companiesUsers.loading,
  companiesUsers_data: state => state.companiesUsers.data
};

const mutations = {
  SET_COMPANIES_USERS_LOADING(state, loadingState) {
    state.companiesUsers.loading = loadingState;
  },
  GET_COMPANIES_USERS_DATA(state, data) {
    state.companiesUsers.data = data;
  }
};
const actions = {
  GET_COMPANIES_USERS_DATA({ commit }) {
    commit("SET_COMPANIES_USERS_LOADING", true);
    return new Promise((resolve, reject) => {
      API.company.getAllByUser(
        "childrens,users",
        resp => {
          commit("GET_COMPANIES_USERS_DATA", resp.data.data);
          commit("SET_COMPANIES_USERS_LOADING", false);
          resolve(resp);
        },
        error => {
          reject(error);
        }
      );
    });
  }
};

export default { state, getters, actions, mutations };



// WEBPACK FOOTER //
// ./src/store/modules/Management/Accounts/CompaniesUsers.js